import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MessageSquare, Truck } from "lucide-react";
import { CTA } from "@/constants/testIds";

export default function CTASection() {
  return (
    <section
      id="quote"
      data-testid={CTA.section}
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[28px] md:rounded-[36px] bg-[#002050] px-8 py-14 md:px-16 md:py-20 lg:px-24 lg:py-24"
        >
          <div className="absolute inset-0 bg-grid-dark opacity-50" />
          <div className="absolute -top-32 -right-32 h-[480px] w-[480px] rounded-full bg-[#0070C0]/40 blur-3xl" />
          <div className="absolute -bottom-32 -left-32 h-[420px] w-[420px] rounded-full bg-[#00AEEF]/25 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="text-xs md:text-sm uppercase tracking-[0.24em] font-bold text-[#00AEEF]">
                Let's move
              </div>
              <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold tracking-tighter text-white leading-[1.02]">
                Got a load to move?{" "}
                <span className="bg-gradient-to-r from-[#00AEEF] via-white to-[#00AEEF] bg-clip-text text-transparent">
                  We've got the truck.
                </span>
              </h2>
              <p className="mt-6 max-w-2xl text-lg md:text-xl text-white/80 leading-relaxed">
                Send us the brief by phone, email or WhatsApp and we'll come
                back to you with a rate — usually within the hour. No portals,
                no logins, no fuss.
              </p>
            </div>

            <div className="lg:col-span-4 flex flex-col gap-3">
              <a
                href="mailto:hello@freightxchange.co.za?subject=Load%20enquiry"
                data-testid={CTA.bookDemo}
                className="group inline-flex items-center justify-center gap-2 bg-[#00AEEF] hover:bg-white text-[#002050] px-7 py-4 rounded-xl font-bold transition-all duration-300 shadow-[0_12px_30px_rgba(0,174,239,0.5)] hover:-translate-y-0.5"
              >
                <MessageSquare className="h-5 w-5" />
                Get a Quote
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </a>
              <a
                href="#carriers"
                data-testid={CTA.contactSales}
                className="group inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-7 py-4 rounded-xl font-bold transition-all duration-300 backdrop-blur"
              >
                <Truck className="h-5 w-5" />
                Become a Carrier
              </a>
              <div className="mt-2 text-center text-xs text-white/60">
                Replies in under an hour · Mon–Fri
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
